__turbopack_context__.v({
  "blockDivider": "WhenView-module__3ACG5W__blockDivider",
  "divider": "WhenView-module__3ACG5W__divider",
  "footer": "WhenView-module__3ACG5W__footer",
  "menuImageContainer": "WhenView-module__3ACG5W__menuImageContainer",
  "menuImageFirstHighlightedWrapper": "WhenView-module__3ACG5W__menuImageFirstHighlightedWrapper",
  "menuImageOtherHighlightedWrapper": "WhenView-module__3ACG5W__menuImageOtherHighlightedWrapper",
  "thematicLinkContainer": "WhenView-module__3ACG5W__thematicLinkContainer",
});
